import React, { useState, useEffect } from 'react';
import apiFetch from '@wordpress/api-fetch';
import { useToast } from '../../utils/Toast.jsx';
import { renderInputRow } from '../../utils/renderInputRow.js';

const TranslationSettingsTab = () => {
  const toast = useToast();
  const [originalSettings, setOriginalSettings] = useState({});
  const [Settings, setSettings]                 = useState({});
  const [loading, setLoading]                   = useState(false);
  const [saved, setSaved]                       = useState(false);

  useEffect(() => {
    const global = window.DOTFW_GLOBAL_OPTIONS || {};
    setSettings(global);
    setOriginalSettings(global);
  }, []);

  const handleSave = () => {
    const changedData = Object.fromEntries(
      Object.entries(Settings).filter(([key, value]) => originalSettings[key] !== value)
    );
    if (Object.keys(changedData).length === 0) {
      toast.info('No changes detected.');
      return;
    }

    setLoading(true);
    setSaved(false);

    apiFetch({ path: '/wp/v2/settings', method: 'POST', data: changedData })
      .then(() => {
        toast.success('Translation settings saved!');
        window.DOTFW_GLOBAL_OPTIONS = { ...(window.DOTFW_GLOBAL_OPTIONS || {}), ...Settings };
        setOriginalSettings(Settings);
        setSaved(true);
        setTimeout(() => setSaved(false), 2500);
      })
      .catch((err) => {
        console.error('Error saving translation settings:', err);
        toast.error('Error saving translation settings.');
      })
      .finally(() => setLoading(false));
  };

  const updateSettings = (key, value) =>
    setSettings((prev) => ({ ...prev, [key]: value }));

  return (
    <div className="tab-root">

      {/* ── Loading overlay ── */}
      {loading && (
        <div className="spinner-overlay" aria-live="polite" aria-label="Saving">
          <div className="spinner-overlay-card">
            <span className="rotating-spinner" aria-hidden="true" />
            <span className="spinner-overlay-text">Saving changes…</span>
          </div>
        </div>
      )}

      {/* ── Section: Labels & Text ── */}
      <div className="tab-section">
        <div className="tab-section-header">
          <div className="tab-section-meta">
            <h3 className="tab-section-title">Translation Settings</h3>
            <p className="tab-section-sub">Text translation settings for various fields</p>
          </div>
        </div>

        <div className="tab-section-body">
          {renderInputRow(
            'Other option text',
            'dotfw_other_option_text',
            'text', [], '',
            Settings, updateSettings, '', true
          )}
          {renderInputRow(
            'Remove donation button text',
            'dotfw_remove_dot_btn_text',
            'text', [], '',
            Settings, updateSettings, '', true
          )}
          {renderInputRow(
            'Donation button text',
            'dotfw_donation_btn_text',
            'text', [], '',
            Settings, updateSettings, '', true
          )}
          {renderInputRow(
            'Donation / tip amount label text',
            'dotfw_dot_amount_label_text',
            'text', [], '',
            Settings, updateSettings,
            'Shown on cart page and checkout page', true
          )}
          {renderInputRow(
            'Alert success message text',
            'dotfw_bot_alt_text',
            'text', [], '',
            Settings, updateSettings, '', true
          )}
        </div>
      </div>

      {/* ── Save row ── */}
      <div className="tab-save-row">
        <div className="tab-save-row-left">
          {saved && (
            <span className="tab-save-badge" aria-live="polite">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <circle cx="7" cy="7" r="6.5" fill="#d1fae5" stroke="#34d399" />
                <path d="M4 7l2 2 4-4" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              All changes saved
            </span>
          )}
        </div>

        <button
          className={`tab-save-btn${loading ? ' tab-save-btn--busy' : ''}`}
          onClick={handleSave}
          disabled={loading}
          type="button"
        >
          {loading ? (
            <>
              <span className="tab-btn-spinner" aria-hidden="true" />
              Saving…
            </>
          ) : (
            <>
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
                <path d="M2 7.5L6 11.5L13 4" stroke="currentColor" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Save Changes
            </>
          )}
        </button>
      </div>

    </div>
  );
};

export default TranslationSettingsTab;